import { useQuery } from '@apollo/client';
import { CasesSendReportV1IndexContainerStaffUserCurrentDocument, CasesSendReportV1IndexContainerStaffUserFieldsFragment } from '../../../../../generated';
import { ComponentQueryLoader } from '../../../../shared/component-query-loader';
import CaseDetails from './index';
import { useOid } from '../../../../../hooks/useOid';
import { getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled } from '../../../../shared/utils/queryOptions';

interface CaseDetailsContainerProps {
  isApplicantSection?: boolean;
}

export const CaseDetailsContainer: React.FC<CaseDetailsContainerProps> = (props) => {
  const oid = useOid();
  const staffUserCurrentQueryOptions = getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled(oid);

  const { data: staffUserData, loading: staffUserLoading, error: staffUserError } = useQuery(CasesSendReportV1IndexContainerStaffUserCurrentDocument, staffUserCurrentQueryOptions);

  return (
    <ComponentQueryLoader
      error={staffUserError}
      loading={staffUserLoading}
      hasData={staffUserData?.staffUserCurrent}
      hasDataComponent={
        <CaseDetails staffUserData={staffUserData?.staffUserCurrent as CasesSendReportV1IndexContainerStaffUserFieldsFragment} isApplicantSection={props.isApplicantSection} />
      }
    />
  );
};
